export default "__VITE_ASSET__G250M0WZ__"